import { render, staticRenderFns } from "./relation-delete-button.vue?vue&type=template&id=79ed514e&scoped=true"
import script from "./relation-delete-button.vue?vue&type=script&lang=js"
export * from "./relation-delete-button.vue?vue&type=script&lang=js"
import style0 from "./relation-delete-button.vue?vue&type=style&index=0&id=79ed514e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ed514e",
  null
  
)

export default component.exports